import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";

//--- Material Control
import {
    DialogActions,
    Button,
    TextField,
    DialogContent,
    DialogTitle,
    Dialog,
    Typography,
    IconButton,
    makeStyles,
    Select,
    MenuItem,
    FormControl,
} from "@material-ui/core";

//--- Material Icon
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));

export default function AddColumn(props) {
    const classes = useStyles();

    const {
        isOpen,
        onClose,
        data,
        action,
    } = props;

    const { register, handleSubmit, errors, setValue, control } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    const onSubmit = (_data) => {
        if (!_data) {
            return;
        }
        console.log('_data', _data)
        action && action(data.table, _data.column)
    };

    return (
        <div>
            <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth="md">
                <DialogTitle disableTypography className="border-bottom">
                    <Typography variant="h6">Thêm Property</Typography>
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <DialogContent className="pt-4 pb-2">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-6">
                                    <label className="text-dark">
                                        Table Name<span className="required"></span>
                                    </label>
                                    <TextField
                                        type="text"
                                        name="tableName"
                                        className="w-100"
                                        disabled
                                        defaultValue={data.table}
                                        inputRef={register({ required: true })}
                                        error={errors.tableName && errors.tableName.type === "required"}
                                    />
                                    {errors.tableName && errors.tableName.type === "required" && (
                                        <span className="error">Trường này là bắt buộc</span>
                                    )}
                                </div>

                                <div className="col-12 col-md-6 col-lg-6">
                                    <label className="text-dark">
                                        Tên Column<span className="required"></span>
                                    </label>
                                    <TextField
                                        type="text"
                                        name="column"
                                        className="w-100"
                                        inputRef={register({
                                            required: true,
                                        })}
                                        onChange={(e) => setValue("column", e.target.value)}
                                        error={
                                            errors.column &&
                                            errors.column.type === "required"
                                        }
                                    />
                                    {errors.column &&
                                        errors.column.type === "required" && (
                                            <span className="error">Trường này là bắt buộc</span>
                                        )}
                                </div>
                            </div>
                        </div>

                    </DialogContent>

                    <DialogActions className="border-top">
                        <Button
                            type="submit"
                            onClick={onClose}
                            variant="contained"
                            startIcon={<CloseIcon />}
                        >
                            Hủy
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            startIcon={<SaveIcon />}
                        >
                            Lưu
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
